/* PLAB-05 (#78). Was two inline <script> blocks in sections/s-main-product.liquid: the
   capture-phase handler for the product content modals, and the SizeCompareModal. Both kept in
   that order, because both bind document click listeners in the capture phase. A sibling of
   section-main-product.js rather than part of it: that file is hand-authored and owns the
   custom element, this one owns two delegated modals. */

  document.addEventListener(
    'click',
    (e) => {
      const trigger = e.target.closest('.js-main-product__content-wrapper');
      if (!trigger) return;

      // Run in CAPTURE and stop the event so the modal "outside click" handler can't close it
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      const title = trigger.getAttribute('data-title') || 'Info';
      const contentHTML =
        trigger.querySelector('.js-main-product__content-text')?.innerHTML || '';

      // Use the modal component API (your s-content-modal exposes this)
      if (window.WOOPF && typeof window.WOOPF.openModal === 'function') {
        window.WOOPF.openModal(title, contentHTML);
        return;
      }

      // Fallback (if WOOPF is not available for some reason)
      const modal = document.querySelector('s-content-modal');
      const modalBody = modal?.querySelector('.js-content-modal__body');
      const modalTitle = modal?.querySelector('.js-content-modal__title');

      if (modal && modalBody && modalTitle) {
        modalBody.innerHTML = contentHTML;
        modalTitle.innerText = title;
        modal.style.display = 'block';
        modal.classList.add('is-open', 'fade-in');
      }
    },
    true // capture phase
  );
  (function () {
    const NS = '[SizeCompareModal]';

    const getModal = () => document.querySelector('.woopf-sc-modal');
    const getContentEl = (modal) =>
      modal?.querySelector('.woopf-sc-modal__content') || modal?.querySelector('.woopf-sc-modal__body');

    let prevOverflow = '';
    let prevPaddingRight = '';
    let prevScrollY = 0;

    const lockScroll = () => {
      prevOverflow = document.body.style.overflow || '';
      prevPaddingRight = document.body.style.paddingRight || '';
      prevScrollY = window.scrollY || 0;

      const w = window.innerWidth - document.documentElement.clientWidth;
      if (w > 0) document.body.style.paddingRight = w + 'px';

      document.body.style.overflow = 'hidden';
    };

    const unlockScroll = () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.paddingRight = prevPaddingRight;
      try { window.scrollTo(0, prevScrollY); } catch {}
    };

    const normalizeSize = (value) => {
      const v = String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');

      const map = {
        'extra small': 'xs',
        extrasmall: 'xs',
        'extra-small': 'xs',

        small: 's',
        medium: 'm',
        large: 'l',

        'extra large': 'xl',
        xlarge: 'xl',
        'extra-large': 'xl',
      };

      return map[v] || v;
    };

    const getCurrentSelectedSize = () => {
      const form = document.querySelector('.s-main-product__variant-picker .c-variant-picker form');
      if (!form) return '';
      const checkedItems = Array.from(
        form.querySelectorAll('.c-variant-picker__item input[type="radio"]:checked')
      );
      const possibleSizes = ['xs', 's', 'm', 'l', 'xl', 'extra small', 'small', 'medium', 'large', 'extra large'];
      for (const radio of checkedItems) {
        const item = radio.closest('.c-variant-picker__item');
        const value = item?.querySelector('.c-variant-picker__text')?.textContent?.trim() || '';
        if (possibleSizes.includes(normalizeSize(value))) return value;
      }
      return '';
    };

    const highlightCurrentSize = (modal) => {
      const currentSize = normalizeSize(getCurrentSelectedSize());
      if (!currentSize || !modal) return;

      modal.querySelectorAll('.woopf-sc__row').forEach((row) => {
        const rowLabel = normalizeSize(row.getAttribute('data-size-label'));
        const rowShort = normalizeSize(row.getAttribute('data-size-short'));

        row.classList.toggle(
          'is-current',
          rowLabel === currentSize || rowShort === currentSize
        );
      });
    };

    const openModal = (html) => {
      const modal = getModal();
      if (!modal) return;
      const contentEl = getContentEl(modal);
      if (contentEl) contentEl.innerHTML = html || '';
      modal.hidden = false;
      highlightCurrentSize(modal);
      requestAnimationFrame(() => {
        modal.classList.add('is-open');
      });
      lockScroll();
    };

    const closeModal = () => {
      const modal = getModal();
      if (!modal) return;
      modal.classList.remove('is-open');
      setTimeout(() => {
        const contentEl = getContentEl(modal);
        if (contentEl) contentEl.innerHTML = '';
        modal.hidden = true;
        unlockScroll();
      }, 220);
    };

    // Open: delegated (works even after section re-render)
    document.addEventListener(
      'click',
      (e) => {
        const trigger = e.target.closest('.js-size-compare-open');
        if (!trigger) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

        const wrap = trigger.closest('.s-main-product__size-compare');
        const tpl = wrap?.querySelector('.js-size-compare-template');
        const html = tpl?.innerHTML || '';

        openModal(html);
      },
      true
    );

    // Close: delegated too (so it still works after re-render)
    document.addEventListener(
      'click',
      (e) => {
        if (!e.target.closest('[data-sc-close]')) return;

        // only close if click happened inside the modal (avoid closing other modals)
        const modal = getModal();
        if (!modal) return;
        if (!e.target.closest('.woopf-sc-modal')) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

        closeModal();
      },
      true
    );

    // ESC close (always checks current modal)
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const modal = getModal();
      if (!modal || modal.hidden) return;
      closeModal();
    });
  })();
